<template>
  <div id="Accounts">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="لیست حساب‌ها"
      description="از طریق این فرم می توانید لیست حساب‌های خود را مشاهده کنید و عملیات های گردش و واریز وجه انجام  دهید"
      :show-back="true"
    >
      <template #toolbar>
        <net-pa-view-toggle
          :value="IsShowCard"
          aria-label="نوع نمایش حساب‌ها"
          @input="ShowCard"
        ></net-pa-view-toggle>
        <ul
          class="nav nav-tabs netpa-list-page-header__tabs card-header-tabs"
          id="myTab"
          role="tablist"
          dir="rtl"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="Detail-tab"
              data-toggle="tab"
              href="#Detailtab"
              role="tab"
              aria-controls="Detailtab"
              aria-selected="true"
              >حساب‌های خودم</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="Logo-tab"
              data-toggle="tab"
              href="#Logotab"
              role="tab"
              aria-controls="Settingtab"
              aria-selected="false"
              >حساب‌های وابسته</a
            >
          </li>
        </ul>
      </template>

      <div class="tab-content text-right p-3" id="Controler">
        <div
          class="tab-pane fade show active"
          id="Detailtab"
          role="tabpanel"
          aria-labelledby="Detail-tab"
        >
          <div class="container mt-3 mb-3">
            <div class="row">
              <div class="col-md-2 col-12">
                <net-pa-filter-dropdown
                  button-id="dropdownMenuButton"
                  label="فیلتر حساب‌ها"
                >
                  <a
                    class="dropdown-item"
                    href="Javascript:;"
                    @click="
                      GetItemCard(false);
                      $ResetTimer();
                    "
                    >حساب‌های دارای مانده
                    <i
                      v-if="selectedBedehi && selectedAllBedehi == false"
                      class="fas fa-check text-success"
                    ></i>
                  </a>
                  <a
                    class="dropdown-item"
                    href="Javascript:;"
                    @click="
                      GetItemCard(true);
                      $ResetTimer();
                    "
                    >همه حساب ها
                    <i
                      v-if="selectedAllBedehi && selectedBedehi == false"
                      class="fas fa-check text-success"
                    ></i>
                  </a>
                </net-pa-filter-dropdown>
              </div>
            </div>
            <div
              v-if="hasOwnAccounts && IsShowCard"
              class="row account-cards-grid"
            >
              <div
                class="col-12 col-md-6 col-xl-4 account-card-col h-100"
                v-for="(item, index) in CardItem"
                :key="index"
              >
                <div
                  class="card Netpa-Shadow border-0 mb-3 costom-card"
                  dir="rtl"
                >
                  <div class="row border-bottom">
                    <div class="text-right col-12">
                      <router-link
                        v-if="item.isTurnover"
                        title="گردش حساب"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: item.id,
                            wwwtblAzaIdAccount: item.wwwtblAzaId,
                            wwwtblSarfaslTypeId: 2,
                          },
                        }"
                        ><span
                          class="fas fa-list text-warning"
                          style="font-size: 16px"
                        ></span
                      ></router-link>
                      <a
                        v-if="$session.get('CustCode') != 868"
                        data-toggle="modal"
                        data-target="#Modal-Mobile"
                        @click="OpenDetail(index)"
                        title="جزئیات حساب"
                        ><span
                          class="fas mx-2 fa-info-circle text-primary Pointer"
                          style="font-size: 15px"
                        ></span
                      ></a>
                      <a
                        v-else
                        data-toggle="modal"
                        data-target="#Modal-Mobile"
                        @click="OpenDetail(index)"
                        title="جزئیات حساب"
                        class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1"
                        >جزئیات حساب</a
                      >
                      <!-- <i v-if="$session.get('CustCode') == 8002 ||$session.get('CustCode') == 866" class="fa fa-qrcode fa-2x float-left Pointer text-secondary" title="ایجاد لینک پرداخت" @click="openGeneratorQR(item)"></i> -->
                      <i
                        v-if="$session.get('CustCode') == 866"
                        class="fa fa-qrcode fa-2x float-left Pointer text-secondary"
                        title="ایجاد لینک پرداخت"
                        @click="openGeneratorQR(item)"
                      ></i>
                      <hr />
                    </div>
                    <div class="col-12 text-right account-card-body-main">
                      <div class="account-card-fields">
                        <div class="account-card-field-row">
                          <label
                            for="lblNoeHesab"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            نوع حساب :
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.desNoe }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblVcode"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            شماره حساب :
                          </label>
                          <span
                            dir="rtl"
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.vCode }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblDate"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            افتتاح حساب :
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.tarix }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblMabSharj"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            شناسه واریز :
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.shenaseVariz }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-if="$session.get('CustCode')==868">************{{ item }}</div> -->
                    <div class="col-12"></div>
                    <div
                      class="col-12 text-center"
                      v-if="item.spName != null && item.spName != ''"
                    >
                      <hr />
                      {{ GetAtach(item) }}

                      <div class="" v-if="item.showScore">
                        <label>
                          <!-- امتیاز شما [ <b class="text-danger">{{ item.emtiazXas }}</b> ] می باشد -->
                          <div
                            class=""
                            v-if="item.showMessageZeroScore == true"
                          >
                            امتیاز شما [
                            <b class="text-danger">{{ GetSumEmtiaz() }}</b>
                            ] و رتبه بندی شما [
                            <b class="text-danger">{{ item.rankNumber }}</b>
                            ] می باشد
                          </div>
                          <div
                            v-if="
                              item.showMessageZeroScore == true &&
                              item.rankNumber == 0
                            "
                            class="d-block text-warning"
                          >
                            {{ item.messageZeroScore }}
                          </div>
                          <small
                            class="badge badge-secondary text-light font-weight-normal px-3 mr-2 Pointer"
                            id="ZamenModal"
                            data-toggle="modal"
                            data-target="#Modal-light"
                            @click="
                              GetAtach(item);
                              AtachVam = true;
                            "
                            >جزئیــات امتیازات</small
                          ></label
                        >
                      </div>
                      <!-- <div class="">
                              <label v-if="item.showMessageZeroScore == true && item.rankNumber != 0"> شما نفر [ </label><span v-if="item.rankNumber != 0" class="font-weight-bold text-danger"> {{ item.rankNumber }} </span><label v-if="item.rankNumber != 0"> ] بر حسب امتیاز مکتسبه می باشید</label>
                              <div v-if="item.showMessageZeroScore == true && item.rankNumber == 0" class="d-block text-warning">{{ item.messageZeroScore }}</div>
                            </div> -->
                    </div>
                    <div
                      class="col-12 text-center my-2"
                      v-if="CheckIsSaham(item) == true"
                    >
                      <hr />
                      <span v-if="item.showScore"
                        >امتیاز وام تعاونی شما :[
                        <span class="text-danger font-weight-bold">{{
                          item.emtiazXas2 == null ? 0 : item.emtiazXas2
                        }}</span>
                        ]</span
                      >
                      <div class="">
                        <label
                          v-if="
                            item.showMessageZeroScore == true &&
                            item.rankNumber2 != 0 &&
                            item.rankNumber2 != null
                          "
                        >
                          شما نفر [ </label
                        ><span
                          v-if="
                            item.rankNumber2 != 0 && item.rankNumber2 != null
                          "
                          class="font-weight-bold text-danger"
                        >
                          {{
                            item.rankNumber2 == null ? 0 : item.rankNumber2
                          }} </span
                        ><label
                          v-if="
                            item.showMessageZeroScore == true &&
                            item.rankNumber2 != 0 &&
                            item.rankNumber2 != null
                          "
                        >
                          ] بر حسب امتیاز مکتسبه می باشید</label
                        >
                        <div
                          v-if="
                            item.showMessageZeroScore == true &&
                            (item.rankNumber2 == 0 || item.rankNumber2 == null)
                          "
                          class="d-block text-warning"
                        >
                          {{ item.messageZeroScore }}
                        </div>
                      </div>
                      <span
                        class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap mt-2"
                        @click="ShowBargeSaham(item)"
                        >نمایش برگه سهام</span
                      >
                    </div>
                  </div>
                  <div class="account-card-balance-footer">
                    <div class="account-card-balance-block">
                      <div class="account-card-balance-row">
                        <label
                          for="lblMojodi"
                          class="account-card-balance-row__label font-weight-bold"
                        >
                          موجودی :
                        </label>
                        <span
                          class="account-card-balance-row__value font-weight-bold text-dark"
                        >
                          {{
                            $Comma3ragham(
                              Number(item.mande.replaceAll(",", "")) +
                                Number(
                                  item.sumMabTaeedNaShode.replaceAll(",", ""),
                                ),
                            )
                          }}
                        </span>
                      </div>
                      <div
                        class="account-card-balance-row"
                        v-if="$session.get('CustCode') != 868"
                      >
                        <label
                          for="lblGhabelBardasht"
                          class="account-card-balance-row__label font-weight-bold"
                        >
                          قابل برداشت :
                        </label>
                        <span
                          class="account-card-balance-row__value font-weight-bold text-dark"
                        >
                          {{
                            $Comma3ragham(
                              Number(item.ghabelBardasht.replaceAll(",", "")),
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2 account-card-actions">
                    <div
                      class="col-md-4 col-12"
                      v-if="
                        $session.get('AccessMenu').filter((x) => x.id == 7)[0]
                          .isMenu &&
                        item.isPayment &&
                        item.tblSarfaslTypeId != 6
                      "
                    >
                      <a
                        type="button"
                        class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                        @click="Deposit(item)"
                        style="font-size: 0.79rem !important"
                        >{{
                          $session.get("IsTaavoniEtebar") == true
                            ? "افزایش اعتبار"
                            : "واریز"
                        }}</a
                      >
                    </div>
                    <div class="col-md-4 col-12">
                      <button
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 13)[0].isMenu &&
                          item.isDebtor == true
                        "
                        type="button"
                        class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                        :disabled="item.ghabelBardasht <= 0"
                        :class="
                          item.ghabelBardasht <= 0
                            ? 'btn-secondary text-dark disabled'
                            : ''
                        "
                        @click="debtor(item)"
                        style="font-size: 0.79rem !important"
                      >
                        برداشت
                      </button>
                      <button
                        type="button"
                        class="d-none"
                        id="debtor"
                        data-toggle="modal"
                        data-target="#Modal-light"
                      ></button>
                    </div>
                    <div class="col-md-4 col-12">
                      <router-link
                        v-if="item.isTurnover == true"
                        title="گردش حساب"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: item.id,
                            wwwtblAzaIdAccount: item.wwwtblAzaId,
                            wwwtblSarfaslTypeId: 2,
                          },
                        }"
                        class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                        style="font-size: 0.79rem !important"
                        >گردش
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="ownAccountsLoaded && !hasOwnAccounts" class="row">
              <div class="col-12">
                <div
                  class="alert alert-warning w-100 text-center accounts-empty-alert"
                >
                  حسابی برای نمایش یافت نشد
                </div>
              </div>
            </div>
            <div v-if="!IsShowCard && hasOwnAccounts" class="row mt-2">
              <div class="col-12 accounts-list-view">
                <vue-bootstrap4-table
                  :rows="rows"
                  :columns="columns"
                  :config="config"
                  :classes="classes"
                >
                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template
                    slot="Emtiaz"
                    slot-scope="props"
                    v-if="props.row.spName != null && props.row.spName != ''"
                  >
                    <!-- {{ props.row.emtiazXas }} -->
                    {{ GetSumEmtiaz() }}
                  </template>
                  <template slot="Detail" slot-scope="props">
                    <a
                      data-toggle="modal"
                      data-target="#Modal-Mobile"
                      @click="OpenDetail(props.row.vbt_id - 1)"
                      class="btn accounts-list-btn accounts-list-btn--detail Pointer"
                      >جزئیات بیشتر</a
                    >
                  </template>
                  <template slot="action-slot" slot-scope="props">
                    <div class="accounts-list-actions">
                      <a
                        v-if="
                          props.row.isPayment &&
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 11)[0].isMenu
                        "
                        @click="Deposit(props.row)"
                        class="btn btn-outline-success accounts-list-btn Pointer"
                        >پرداخت</a
                      >
                      <router-link
                        v-if="props.row.isTurnover == true"
                        title="گردش"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: props.row.id,
                            wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                            wwwtblSarfaslTypeId: 2,
                          },
                        }"
                        class="btn btn-outline-dark accounts-list-btn"
                      >
                        گردش
                      </router-link>
                      <button
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 13)[0].isMenu &&
                          props.row.isDebtor == true
                        "
                        type="button"
                        class="btn btn-outline-danger accounts-list-btn"
                        :disabled="props.row.ghabelBardasht <= 0"
                        :class="
                          props.row.ghabelBardasht <= 0
                            ? 'btn-secondary text-dark disabled'
                            : ''
                        "
                        @click="debtor(props.row.id)"
                      >
                        برداشت
                      </button>
                      <span
                        v-if="CheckIsSaham(props.row) == true"
                        class="btn btn-outline-dark accounts-list-btn Pointer"
                        @click="ShowBargeSaham(props.row)"
                        >برگه سهام</span
                      >
                      <span
                        v-if="
                          props.row.spName != null && props.row.spName != ''
                        "
                        class="btn btn-outline-dark accounts-list-btn Pointer"
                        data-toggle="modal"
                        data-target="#Modal-light"
                        @click="GetAtach(props.row)"
                        >امتیازات</span
                      >
                    </div>
                    <p
                      v-if="CheckIsSaham(props.row) == true"
                      class="accounts-list-meta mb-0"
                    >
                      امتیاز وام تعاونی:
                      <span class="text-danger font-weight-bold">{{
                        props.row.emtiazXas2 == null ? 0 : props.row.emtiazXas2
                      }}</span>
                    </p>
                    <button
                      type="button"
                      class="d-none"
                      id="debtor"
                      data-toggle="modal"
                      data-target="#Modal-light"
                    ></button>
                  </template>

                  <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                  </template>
                </vue-bootstrap4-table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade show"
          id="Logotab"
          role="tabpanel"
          aria-labelledby="Detail-tab"
        >
          <div class="container mt-3 mb-3">
            <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
              <div class="col-md-2 col-12">
                <net-pa-filter-dropdown
                  button-id="dropdownMenuButton2"
                  label="حساب‌های وابسته"
                >
                  <a
                    class="dropdown-item"
                    href="javascript:;"
                    v-for="item in groupBy"
                    :key="item.Id"
                    :id="item.wwwtblAzaId"
                    @click="
                      GetSahebHesab(item.wwwtblAzaId, false);
                      $ResetTimer();
                    "
                  >
                    {{ item.nameFamily }}</a
                  >
                  <hr />
                  <a
                    class="dropdown-item"
                    href="Javascript:;"
                    @click="
                      GetSahebHesab(0, true);
                      $ResetTimer();
                    "
                    >همه حساب‌های وابسته
                    <i class="fas fa-check text-success"></i>
                  </a>
                </net-pa-filter-dropdown>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12">
                <div class="alert alert-warning w-100 text-center">
                  در حال حاضر حساب‌های وابسته شما صفر می‌باشد
                </div>
              </div>
            </div>
            <div
              v-if="hasDependentAccountsList && IsShowCard"
              class="row account-cards-grid"
            >
              <div
                class="col-12 col-md-6 col-xl-4 account-card-col"
                v-for="(item, index) in FilterCardItemTaahodatSahebHesab"
                :key="index"
              >
                <div
                  class="card border-0 mb-3 costom-card-sahebanhesab"
                  dir="rtl"
                >
                  <div class="row border-bottom">
                    <div class="text-right col-12">
                      <router-link
                        v-if="item.isTurnover == true"
                        title="گردش حساب"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: item.id,
                            wwwtblSarfaslTypeId: 2,
                          },
                        }"
                        ><span
                          class="fas fa-list text-warning"
                          style="font-size: 16px"
                        ></span
                      ></router-link>

                      <a
                        data-toggle="modal"
                        data-target="#Modal-Mobile"
                        @click="OpenDetailSahebanHesab(index)"
                        title="جزئیات حساب"
                        ><i
                          class="fas mx-2 fa-info-circle text-primary Pointer"
                          style="font-size: 15px"
                        ></i
                      ></a>
                      <small class="text-dark float-left ml-3"
                        ><span
                          class="fas fa-user text-success"
                          style="font-size: 15px"
                        ></span>
                        {{ item.nameFamily }}
                      </small>
                      <hr />
                    </div>
                    <div class="col-12 text-right account-card-body-main">
                      <div class="account-card-fields">
                        <div class="account-card-field-row">
                          <label
                            for="lblNoeHesab"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            نوع حساب:
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.desNoe }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblVcode"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            شماره حساب:
                          </label>
                          <span
                            dir="rtl"
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.vCode }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblDate"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            افتتاح حساب:
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.tarix }}
                          </span>
                        </div>
                        <div class="account-card-field-row">
                          <label
                            for="lblMabSharj"
                            class="account-card-field-row__label font-weight-bold"
                          >
                            شناسه واریز:
                          </label>
                          <span
                            class="account-card-field-row__value font-weight-bold text-dark"
                          >
                            {{ item.shenaseVariz }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="account-card-balance-footer">
                    <div class="account-card-balance-block">
                      <div class="account-card-balance-row">
                        <label
                          class="account-card-balance-row__label font-weight-bold"
                        >
                          موجودی:
                        </label>
                        <span
                          class="account-card-balance-row__value font-weight-bold text-dark"
                        >
                          {{
                            $Comma3ragham(
                              Number(item.mande.replaceAll(",", "")) +
                                Number(
                                  item.sumMabTaeedNaShode.replaceAll(",", ""),
                                ),
                            )
                          }}
                        </span>
                      </div>
                      <div class="account-card-balance-row">
                        <label
                          class="account-card-balance-row__label font-weight-bold"
                        >
                          قابل برداشت:
                        </label>
                        <span
                          class="account-card-balance-row__value font-weight-bold text-dark"
                        >
                          {{
                            $Comma3ragham(
                              Number(item.ghabelBardasht.replaceAll(",", "")),
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2 account-card-actions">
                    <div
                      class="col-md-4 col-12"
                      v-if="
                        $session.get('AccessMenu').filter((x) => x.id == 7)[0]
                          .isMenu &&
                        item.isPayment &&
                        item.tblSarfaslTypeId != 6
                      "
                    >
                      <a
                        type="button"
                        class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                        @click="Deposit(item)"
                        style="font-size: 0.79rem !important"
                        >{{
                          $session.get("IsTaavoniEtebar") == true
                            ? "افزایش اعتبار"
                            : "واریز"
                        }}</a
                      >
                    </div>
                    <div class="col-md-4 col-12">
                      <button
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 13)[0].isMenu &&
                          item.isDebtor == true
                        "
                        type="button"
                        class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                        :disabled="item.ghabelBardasht <= 0"
                        :class="
                          item.ghabelBardasht <= 0
                            ? 'btn-secondary text-dark disabled'
                            : ''
                        "
                        @click="debtor(item)"
                        style="font-size: 0.79rem !important"
                      >
                        برداشت
                      </button>
                      <button
                        type="button"
                        class="d-none"
                        id="debtor"
                        data-toggle="modal"
                        data-target="#Modal-light"
                      ></button>
                    </div>
                    <div class="col-md-4 col-12">
                      <router-link
                        v-if="item.isTurnover == true"
                        title="گردش حساب"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: item.id,
                            wwwtblSarfaslTypeId: 2,
                            wwwtblAzaIdAccount: item.wwwtblAzaId,
                          },
                        }"
                        class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                        style="font-size: 0.79rem !important"
                        >گردش
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!IsShowCard && hasDependentAccountsList"
              class="row mt-2"
            >
              <div class="col-12 accounts-list-view">
                <vue-bootstrap4-table
                  :rows="rows2"
                  :columns="columns2"
                  :config="config"
                  :classes="classes"
                >
                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template slot="action-slot" slot-scope="props">
                    <div class="accounts-list-actions">
                      <a
                        v-if="
                          props.row.isPayment &&
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 11)[0].isMenu
                        "
                        @click="Deposit(props.row)"
                        class="btn btn-outline-success accounts-list-btn Pointer"
                        >پرداخت</a
                      >
                      <router-link
                        v-if="props.row.isTurnover == true"
                        title="گردش"
                        :to="{
                          name: 'Turnover',
                          params: {
                            TaahodatId: props.row.id,
                            wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                            wwwtblSarfaslTypeId: 2,
                          },
                        }"
                        class="btn btn-outline-dark accounts-list-btn"
                      >
                        گردش
                      </router-link>
                      <button
                        v-if="
                          $session
                            .get('AccessMenu')
                            .filter((x) => x.id == 13)[0].isMenu &&
                          props.row.isDebtor == true
                        "
                        type="button"
                        class="btn btn-outline-danger accounts-list-btn"
                        :disabled="props.row.ghabelBardasht <= 0"
                        :class="
                          props.row.ghabelBardasht <= 0
                            ? 'btn-secondary text-dark disabled'
                            : ''
                        "
                        @click="debtor(props.row.id)"
                      >
                        برداشت
                      </button>
                    </div>
                    <button
                      type="button"
                      class="d-none"
                      id="debtor"
                      data-toggle="modal"
                      data-target="#Modal-light"
                    ></button>
                  </template>
                  <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                  </template>
                </vue-bootstrap4-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </net-pa-list-page-card>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <!-- <debtor v-if="AtachVam==false && $store.state.renderComponent" :TaahodatId="taahodatId"></debtor> -->
        <div class="container-fluid text-center" dir="rtl">
          <div class="row">
            <div
              class="col-12 alert bg-dark text-light"
              style="font-size: 15px !important"
            >
              جدول امتیازات وام شما به صورت زیر می باشد
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width: 60% !important">عنوان</th>
                  <th scope="col" style="width: 20% !important">امتیاز</th>
                  <th scope="col" style="width: 20% !important">
                    امتیاز مکتسبه
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in GridDataAtachVam"
                  :key="index"
                  :class="item.Base == null ? 'bg-gray' : ''"
                >
                  <td>{{ item.Onvan }}</td>
                  <td>{{ item.Base != null ? item.Base : "" }}</td>
                  <td
                    :class="
                      item.Emtiaz > 0 && item.Emtiaz != null
                        ? 'font-weight-bold'
                        : ''
                    "
                  >
                    {{ item.Base != null ? item.Emtiaz : "" }}
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="2"
                    class="bg-dark text-light"
                    style="width: 80% !important"
                  >
                    جمع امتیازات
                  </td>
                  <td
                    class="font-weight-bold text-danger"
                    style="width: 20% !important"
                  >
                    {{ CalcEmtiazXasForTable(GridDataAtachVam) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-slot:HeaderModalInfo>
        <span>
          <i
            class="fas fa-info-circle text-dark mx-2"
            style="font-size: 16 !important"
          ></i>
          <span
            style="font-size: 16 !important"
            class="text-light font-weight-bold"
            >جزئیات حساب</span
          ></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="netpa-account-detail-modal" dir="rtl">
          <div
            v-if="detailInModal != null"
            class="netpa-account-detail-modal__panel"
          >
            <div class="netpa-account-detail-modal__header">
              <h6 class="netpa-account-detail-modal__title">
                <i class="fas fa-info-circle ml-2"></i>
                جزئیات حساب
              </h6>
              <hr class="netpa-account-detail-modal__header-divider" />
              <p class="netpa-account-detail-modal__account-type">
                <i class="fas fa-money-check ml-2"></i>
                {{ CardItem[detailInModal].desNoe }}
              </p>
            </div>

            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >شماره حساب:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItem[detailInModal].vCode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مانده:</span>
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  $Comma3ragham(CardItem[detailInModal].mande)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ افتتاح حساب:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItem[detailInModal].tarix
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ شروع شارژ:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItem[detailInModal].tarixShoroAghsat
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-ban ml-2"></i>
              مسدودی‌ها
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مسدودی:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(CardItem[detailInModal].mablaghSood)
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مسدودی بابت دریافت تسهیلات:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItem[detailInModal].mablaghMasdodBabateDarTashilat,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مسدودی بابت معرفی:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItem[detailInModal].mablaghMasdodBabateMoarefi,
                  )
                }}</span>
              </div>
            </div>

            <div
              class="netpa-account-detail-modal__score"
              v-if="hasAccountDetailScore(CardItem[detailInModal])"
            >
              <p
                class="netpa-account-detail-modal__score-note"
                v-if="
                  CardItem[detailInModal].spName != null &&
                  CardItem[detailInModal].spName != ''
                "
              >
                امتیاز وام مسکن شما [
                <strong>{{ CardItem[detailInModal].emtiazXas }}</strong>
                ] می باشد
              </p>
              <p
                class="netpa-account-detail-modal__score-note"
                v-if="CheckIsSaham(CardItem[detailInModal])"
              >
                امتیاز وام تعاونی شما [
                <strong>{{ CardItem[detailInModal].emtiazXas }}</strong>
                ] می باشد
              </p>
            </div>
          </div>

          <div
            v-if="detailInModalSahebHesab != null"
            class="netpa-account-detail-modal__panel"
          >
            <div class="netpa-account-detail-modal__header">
              <h6 class="netpa-account-detail-modal__title">
                <i class="fas fa-info-circle ml-2"></i>
                جزئیات حساب
              </h6>
              <hr class="netpa-account-detail-modal__header-divider" />
              <p class="netpa-account-detail-modal__account-type">
                <i class="fas fa-money-check ml-2"></i>
                {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].desNoe }}
              </p>
            </div>

            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >شماره حساب:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مانده:</span>
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ افتتاح حساب:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarix
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >تاریخ شروع شارژ:</span
                >
                <span class="netpa-account-detail-modal__value" dir="rtl">{{
                  CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                    .tarixShoroAghsat
                }}</span>
              </div>
            </div>

            <h6 class="netpa-account-detail-modal__section-title">
              <i class="fas fa-ban ml-2"></i>
              مسدودی‌ها
            </h6>
            <div class="netpa-account-detail-modal__grid">
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label">مسدودی:</span>
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghSood,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مسدودی بابت دریافت تسهیلات:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghMasdodBabateDarTashilat,
                  )
                }}</span>
              </div>
              <div class="netpa-account-detail-modal__item">
                <span class="netpa-account-detail-modal__label"
                  >مسدودی بابت معرفی:</span
                >
                <span class="netpa-account-detail-modal__value">{{
                  $Comma3ragham(
                    CardItemTaahodatSahebHesab[detailInModalSahebHesab]
                      .mablaghMasdodBabateMoarefi,
                  )
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import NetPaViewToggle from "../Tools/NetPa/NetPaViewToggle.vue";
import NetPaFilterDropdown from "../Tools/NetPa/NetPaFilterDropdown.vue";
import Debtor from "./Debtor.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import html2pdf from "html2pdf.js";
import Num2persian from "num2persian";
export default {
  data() {
    return {
      logo: {},
      emza1: {},
      emza2: {},
      GridDataAtachVam: [],
      AtachVam: false,
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      taahodatId: 0,
      detailInModal: null,
      detailInModalSahebHesab: null,
      selectedBedehi: true,
      selectedAllBedehi: false,
      IsTaahodatSahebHesab: false,
      IsShowCard: true,
      groupBy: null,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره",
          name: "vCode",
        },
        {
          label: "افتتاح حساب",
          name: "tarix",
        },
        {
          label: "شناسه واریز ",
          name: "shenaseVariz",
        },
        {
          label: "موجودی",
          name: "NewMande",
        },
        {
          label: "قابل برداشت",
          name: "NewghabelBardasht",
          visibility: this.$session.get("CustCode") == 868 ? false : true,
        },
        {
          label: "جزئیات",
          name: "Detail",
          visibility: true,
        },
        {
          label: "امتیاز شما",
          name: "Emtiaz",
          visibility: true,
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره",
          name: "vCode",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
        },
        {
          label: "افتتاح حساب",
          name: "tarix",
        },
        {
          label: "شناسه واریز ",
          name: "shenaseVariz",
        },
        {
          label: "موجودی",
          name: "NewMande",
        },
        {
          label: "قابل برداشت",
          name: "NewghabelBardasht",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped  ",
      },
      DataAxiosSaham: {},
    };
  },
  components: {
    NetPaListPageCard,
    NetPaViewToggle,
    NetPaFilterDropdown,
    ModalCustom,
    Debtor,
    VueBootstrap4Table,
    loading,
    html2pdf,
  },
  computed: {
    ownAccountsLoaded() {
      return Array.isArray(this.CardItem);
    },
    hasOwnAccounts() {
      return this.ownAccountsLoaded && this.CardItem.length > 0;
    },
    hasDependentAccountsList() {
      return (
        this.IsTaahodatSahebHesab &&
        Array.isArray(this.FilterCardItemTaahodatSahebHesab) &&
        this.FilterCardItemTaahodatSahebHesab.length > 0
      );
    },
  },
  mounted() {
    this.GetItemCard(true);
    this.GetItemCardTaahodatSahebHesab();
    this.getSahamsettings();
  },
  updated() {
    if (!this.IsShowCard) {
      this.syncAccountsListPaginationInput();
    }
  },
  methods: {
    GetSahebHesab(id, IsAll) {
      let info;
      let list = [];
      if (IsAll) {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab;
        for (
          let index = 0;
          index < this.FilterCardItemTaahodatSahebHesab.length;
          index++
        ) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] =
            Number(this.FilterCardItemTaahodatSahebHesab[index].mande) +
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode,
            );
          info["NewghabelBardasht"] =
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht,
            ) +
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode,
            );
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      } else {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab =
          this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id);
        for (
          let index = 0;
          index < this.FilterCardItemTaahodatSahebHesab.length;
          index++
        ) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] =
            Number(this.FilterCardItemTaahodatSahebHesab[index].mande) +
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode,
            );
          info["NewghabelBardasht"] =
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht,
            ) +
            Number(
              this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode,
            );
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      }
    },
    ShowCard(status) {
      this.IsShowCard = status;
      if (!status) {
        this.syncAccountsListPaginationInput();
      }
    },
    syncAccountsListPaginationInput() {
      this.$nextTick(() => {
        const inputs = this.$el.querySelectorAll(
          '.accounts-list-view .pagination input[type="number"]',
        );
        inputs.forEach((input) => {
          input.placeholder = "";
          input.setAttribute("aria-label", "شماره صفحه");
        });
      });
    },
    GetItemCard(IsAll) {
      let info;
      let list = [];
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAll) {
          this.CardItem = data.filter((x) => x.tblSarfaslTypeId != 6);
          this.selectedBedehi = false;
          this.selectedAllBedehi = true;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] =
              data[index].mande + data[index].sumMabTaeedNaShode;
            info["NewghabelBardasht"] =
              data[index].ghabelBardasht + data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(this.CardItem);
        } else {
          this.CardItem = data.filter(
            (x) => x.mande > 0 && x.tblSarfaslTypeId != 6,
          );
          this.selectedBedehi = true;
          this.selectedAllBedehi = false;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            if (info.mande > 0 && info.tblSarfaslTypeId != 6) {
              info["NewMande"] =
                data[index].mande + data[index].sumMabTaeedNaShode;
              info["NewghabelBardasht"] =
                data[index].ghabelBardasht + data[index].sumMabTaeedNaShode;
              list.push(info);
            }
          }
          this.rows = this.$FormatMablaghGrid(list.filter((x) => x.mande > 0));
        }
      });
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_SahebHesab.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.CardItemTaahodatSahebHesab = data.filter(
            (x) => x.tblSarfaslTypeId != 6,
          );
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (
              !unique.some(
                (obj) =>
                  obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value,
              )
            ) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.groupBy = result;
        })
        .finally(() => {
          if (this.$session.get("UserFromAccount")) {
            if (this.$session.get("UserFromAccount")[1] == true) {
              if (
                this.$session.get("UserFromAccount")[0] !=
                this.$session.get("UserInfoNetPa").wwwtblAzaId
              ) {
                document.getElementById("Logo-tab").click();
                document
                  .getElementById(this.$session.get("UserFromAccount")[0])
                  .click();
                this.$session.remove("UserFromAccount");
              } else {
                this.$session.remove("UserFromAccount");
              }
            }
          }
          this.loadingRender = false;
        });
    },
    Deposit(Taahodat) {
      // console.log("🤦🏻‍♂️ ~ file: Accounts.vue:925 ~ Taahodat:", Taahodat.tblSarfaslTypeId)
      this.$router.push({
        name: "Deposit",
        params: {
          TaahodatItem: Taahodat,
          wwwtblAzaIdAccount: Taahodat.wwwtblAzaId,
          IsTashilat: false,
        },
      });
    },
    Payment() {
      this.$router.push({
        name: "Debtor",
      });
    },
    debtor(row) {
      var GhebelBardasht =
        Number(row.ghabelBardasht.replace(/,/g, "").replace(/\./g, "")) +
        Number(row.sumMabTaeedNaShode.replace(/,/g, "").replace(/\./g, ""));
      this.$router.push({
        name: "Debtor",
        params: { TaahodatId: row.id, GhebelBardasht: GhebelBardasht },
      });
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null;
      this.detailInModal = index;
      const item = this.CardItem && this.CardItem[index];
      if (item && item.spName != null && item.spName !== "") {
        this.GetAtach(item);
      }
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null;
      this.detailInModalSahebHesab = index;
    },
    GetAtach(row) {
      if (row.spName != null) {
        let Params = "";
        let QParams = row.spName.split("@");

        for (let index = 1; index < QParams.length; index++) {
          Params = Params + "@" + QParams[index];
        }
        if (Params.match("@ShmoareOzv = 0") != null) {
          Params = Params.replaceAll(
            "@ShmoareOzv = 0",
            "@ShmoareOzv =' " +
              this.$session.get("UserInfoNetPa").shomareOzv.trim() +
              "'",
          );
        }
        if (Params.match("@ShmoareOzv= 0") != null) {
          Params = Params.replaceAll(
            "@ShmoareOzv= 0",
            "@ShmoareOzv =' " +
              this.$session.get("UserInfoNetPa").shomareOzv.trim() +
              "'",
          );
        }
        if (Params.match("@ShmoareOzv=0") != null) {
          Params = Params.replaceAll(
            "@ShmoareOzv=0",
            "@ShmoareOzv =' " +
              this.$session.get("UserInfoNetPa").shomareOzv.trim() +
              "'",
          );
        }
        var DataAxios = {
          ArryfildValue: "",
          Method: "Post",
          Action: "InsNewVam/AatachVam",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Params", Params);
        formData.append("Query", QParams[0]);
        DataAxios.ArryfildValue = formData;
        this.$PostFormData(DataAxios).then((data) => {
          let a = JSON.parse(data);
          this.GridDataAtachVam = a;
        });
      }
    },
    GetSumEmtiaz() {
      let SumEmtiaz = 0;
      this.GridDataAtachVam.forEach((el) => {
        SumEmtiaz += el.Emtiaz;
      });
      return SumEmtiaz;
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GetSahamSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwshobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      DataAxios_GetSaham.ArryfildValue = formData;
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        // console.log('😎 ~ this.$PostFormData ~ data:', data)
        this.DataAxiosSaham = data.data;
        this.logo = data.logo;
        this.emza1 = data.emza1;
        this.emza2 = data.emza2;
      });
    },
    CheckIsSaham(row) {
      // console.log("*-*-*-*-*-*-*-*-*-**--*-*-*-*-*-");
      // console.log(row.wwwtblNoeId);
      // console.log(this.DataAxiosSaham.wwwtblNoeId);
      return this.DataAxiosSaham.wwwtblNoeId == row.wwwtblNoeId;
    },
    hasAccountDetailScore(item) {
      if (!item || this.$session.get("CustCode") != 868) {
        return false;
      }
      return (
        (item.spName != null && item.spName !== "") || this.CheckIsSaham(item)
      );
    },
    ShowBargeSaham(item) {
      var html = ``;
      var Taahoadat = item;
      // this.$router.push({ name: 'PrintBargeSaham', params: { Data: this.DataAxiosSaham, Taahoadat: item, Image: { logo: this.logo, emza1: this.emza1, emza2: this.emza2 } } })
      if (this.$session.get("CustCode") == 574) {
        html = `
        <div class="container Border-Rouded Border  p-1 px-2 " style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
          <div class="row " style="height:14cm !important; width:20.2cm !important" >
          <div class="m-1 py-2 col-12">
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4 text-center">تعاونوا علی البر والتقوی</div>
              <div class="col-4">
                <span class="font-16px">شماره سریال : </span><span>${
                  this.DataAxiosSaham.serialNumber
                }</span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-8 col-12 font-weight-bold text-right pr-5" style="font-size: 15px !important">${
                this.$session.get("UserInfoNetPa").customerName
              }</div>
              <div class="col-md-4 col-12 font-16px">تاریخ صدور : ${this.$GetJalaliDate()}</div>
            </div>
            <div class="text-center " style="margin-bottom:1cm;margin-top:1cm;"> << برگه سهام  >> </div>
            <hr/>
            <div class="row mt-2">
              <div class="col-md-2 col-12">
                <span class="font-16px">شماره ثبت : </span><span class="font-16px">${
                  this.DataAxiosSaham.shomareSabt
                }</span>
              </div>
              <div class="col-md-3 col-12">
                <span class="font-16px">شناسه ملی :</span><span class="font-16px">${
                  this.DataAxiosSaham.shenaseMeli
                }</span>
              </div>
              <div class="col-md-3 text-right col-12">
                <span class="mr-5 font-16px"> تعداد سهام</span>
                <span class="font-weight-bold"> ${Math.floor(
                  Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") /
                    this.DataAxiosSaham.arzeshHarSahm,
                )} سهم</span>
                
              </div>
              <div class="col-md-4 text-right col-12">
                <span class="font-16px">مبلغ اسمی هر سهم :</span><span class="font-16px">${this.$Comma3ragham(
                  this.DataAxiosSaham.arzeshHarSahm,
                )}</span> ریال
              </div>
            </div>
            <div class="text-center mt-2"> مشخصات صاحب برگه سهام </div>
            <div class="row mt-3">
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> نام خانوادگی و نام :</span><span class="font-weight-bold font-16px">${
                  this.$session.get("UserInfoNetPa").ozvFamily
                } ${this.$session.get("UserInfoNetPa").ozvName} </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> نام پدر :</span><span class="font-weight-bold font-16px"> ${
                  this.$session.get("UserInfoNetPa").pedar
                    ? this.$session.get("UserInfoNetPa").pedar
                    : "______"
                } </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px"> ${
                  this.$session.get("UserInfoNetPa").codeMeli
                    ? this.$session.get("UserInfoNetPa").codeMeli
                    : "______"
                } </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> شماره عضویت سهامدار:</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                  this.$session.get("UserInfoNetPa").shomareOzv
                } </span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-2 col-12 text-left">
                <div class="font-10px"> هیئت مدیره</div>
                <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
              </div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${
                  this.emza1.binary
                }" />
              </div>
              <div class="col-md-2 col-12 text-left">
                <div class="font-10px">مدیر عامل</div>
                <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
              </div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${
                  this.emza2.binary
                }" />
                
              </div>
              <div class="col-md-2 col-12 text-left"><div class="font-10px">مهر شرکت</div></div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${
                  this.logo.binary
                }" />
              </div>
            </div>
            <div class="px-5 mt-4 text-center" style="font-size:11px !important;">
                نقل و انتقال سهام صرفا در محل شرکت تعاونی واقع در آدرس تبریز، کوچه شفائیه ف بلوار شهدا ، کد پستی 5134916579
            </div>
            <div class="px-5 text-center mt-1" style="font-size:11px !important;">
                تلفن 35291357 و فاکس 35259200 امکان پذیز می باشد
            </div>
            <div class="px-5 mt-1 text-center" style="font-size:11px !important;">
                برگه های سهام صادر شده قبلی فاقد اعتبار می باشد .
            </div>
            <div class="mt-3 text-center ml-3" style="font-size:11px !important;">
                برگه مخصوص سهامدار 
            </div>
          </div>
          </div>
        </div>
        `;
      }
      if (
        this.$session.get("CustCode") == 868 ||
        this.$session.get("CustCode") == 886
      ) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row Border print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class=" m-1 py-2 w-100 col-12">
                    <div class="row">
                      <div class="col-md-3 col-12"></div>
                      <div class="col-md-6 col-12">بسمه تعالی</div>
                      <div class="col-md-3 col-12"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 col-12">
                        <div class="row">
                          <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره و تاریخ ثبت</span></div>
                          <div class="col-md-6 col-12 text-center pr-0">
                            <div class="border-bottom">${
                              this.DataAxiosSaham.shomareSabt
                            }</div>
                            <div class="mt-2">${
                              this.DataAxiosSaham.tarixSabt
                            }</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="font-weight-bold" style="font-size: 15px" >شرکت تعاونی اعتبار کارکنان وزارت امور اقتصادی و دارایی</div>
                        <div class="font-weight-bold mt-2" style="font-size: 15px">برگه سهــام</div>
                      </div>
                      <div class="col-md-3 col-12 text-right pr-0">
                        <img style="max-width:4cm;" src="data:image/png;base64,${
                          this.logo.binary
                        } " />
                      </div>
                    </div>
                    <!-- <div class="row mt-5">
                                <div class="col-12 text-right"><span class="mr-5 font-weight-bold" style="font-size:15px;">برگه سهــام</span></div>
                            </div> -->
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").ozvName
                        } ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> نام پدر :</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").pedar
                            ? this.$session.get("UserInfoNetPa").pedar
                            : "______"
                        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").codeMeli
                            ? this.$session.get("UserInfoNetPa").codeMeli
                            : "______"
                        } </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> شماره شناسنامه:</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").shenasname == null
                            ? "______"
                            : this.$session.get("UserInfoNetPa").shenasname
                        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> شماره عضویت سهامدار:</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                          this.$session.get("UserInfoNetPa").shomareOzv
                        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center"></div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px mr-5"> دارای تعداد </span>
                        <span class="font-weight-bold font-16px"> ${Math.floor(
                          Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") /
                            this.DataAxiosSaham.arzeshHarSahm,
                        )} </span>
                        <span class="font-16px"> سهــــم </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> به ارزش اسمی هر سهـــم </span>
                        <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(
                          this.DataAxiosSaham.arzeshHarSahm,
                        )} </span>
                        <span class="font-16px"> ریال </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> تا تاریخ </span>
                        <span class="font-weight-bold font-16px"> ${this.$GetJalaliDateTime()} </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center"><span class="font-16px"> محل خدمت :</span><span class="font-weight-bold font-16px"> وزارت امور اقتصادی ودارایی </span></div>
                      <div class="col-md-8 col-12 text-center"></div>
                    </div>
                    <div class="row mt-4">
                      <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      <div class="col-md-12 col-12 text-center">
                        <div class="row">
                          <div class="col-md-3 col-12 text-left">
                            <div class="font-16px">رئیس هیئت مدیره</div>
                            <div class="font-16px">${
                              this.DataAxiosSaham.pishNevis1
                            }</div>
                          </div>
                          <div class="col-md-3 col-12 text-right pr-0 pt-0">
                            <img style="height: 10vh" src="data:image/png;base64,${
                              this.emza1.binary
                            }" />
                          </div>
                          <div class="col-md-3 col-12 text-left">
                            <div class="font-16px">مدیر عامل</div>
                            <div class="font-16px">${
                              this.DataAxiosSaham.pishNevis2
                            }</div>
                          </div>
                          <div class="col-md-3 col-12 text-right pr-0 pt-0">
                            <img style="height: 10vh" src="data:image/png;base64,${
                              this.emza2.binary
                            }" />
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-md-2 col-12 text-center"></div> -->
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 932) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${
                                    this.$session.get("UserInfoNetPa").perNo ==
                                    null
                                      ? " - - - "
                                      : this.$session.get("UserInfoNetPa").perNo
                                  }</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 15px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 15px">شرکت تعاونی اعتبار کارکنان سازمان تامین اجتماعی</div>
                              <div class="font-weight-bold mt-1" style="font-size: 15px">( سهامی خاص )</div>
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(
                                  this.DataAxiosSaham.arzeshHarSahm,
                                )} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${
                                  this.$session.get("UserInfoNetPa").ozvName
                                } ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar
                                  ? this.$session.get("UserInfoNetPa").pedar
                                  : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${
                                this.$session.get("UserInfoNetPa").codeMeli
                              } </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${
                            this.logo.binary
                          } " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${
                              this.DataAxiosSaham.shomareSabt
                            }</div>
                            <div class="">شناسه ملی : ${
                              this.DataAxiosSaham.shenaseMeli
                            }</div>
                            <div class="">تاریخ ثبت شرکت: ${
                              this.DataAxiosSaham.tarixSabt
                            }</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center font-weight-bold" style="font-size: 15px !important">
                          <span>این ورقه نماینده یک سهم </span>
                          <span>${this.Mab2persian()}</span>
                          <span> می باشد </span>
                        </div>
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-3 col-12 text-left">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis1
                              }</div>
                            </div>
                            <div class="col-md-3 col-12 text-right pr-0 pt-0">
                              <img style="height: 10vh" src="data:image/png;base64, ${
                                this.emza1.binary
                              }" />
                            </div>
                            <div class="col-md-3 col-12 text-left">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis2
                              }</div>
                            </div>
                            <div class="col-md-3 col-12 text-right pr-0 pt-0">
                              <img style="height: 10vh" src="data:image/png;base64,${
                                this.emza2.binary
                              }" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 352) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${
                                    this.$session.get("UserInfoNetPa").perNo ==
                                    null
                                      ? " - - - "
                                      : this.$session.get("UserInfoNetPa").perNo
                                  }</div>
                                </div>

                                <div class="col-md-6 col-12 text-left mt-2"><span class="">تاریخ صدور</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${this.$GetJalaliDate()}</div>
                                </div>

                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 13px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 13px">تعاوني اعتبار كاركنان سازمان آموزش فني حرفه اي كشور</div>
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(
                                  this.DataAxiosSaham.arzeshHarSahm,
                                )} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${
                                  this.$session.get("UserInfoNetPa").ozvName
                                } ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar
                                  ? this.$session.get("UserInfoNetPa").pedar
                                  : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${
                                this.$session.get("UserInfoNetPa").codeMeli
                              } </span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="mr-5 font-16px"> تعداد سهام</span><span class="font-weight-bold"> ${Math.floor(
                                Taahoadat.mande
                                  .replace(/,/g, "")
                                  .replace(/\./g, "") /
                                  this.DataAxiosSaham.arzeshHarSahm,
                              )} سهم</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${
                            this.logo.binary
                          } " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${
                              this.DataAxiosSaham.shomareSabt
                            }</div>
                            <div class="">شناسه ملی : ${
                              this.DataAxiosSaham.shenaseMeli
                            }</div>
                            <div class="">تاریخ ثبت شرکت: ${
                              this.DataAxiosSaham.tarixSabt
                            }</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis1
                              }</div>
                              <img style="height: 10vh;margin-top:-35px;" src="data:image/png;base64, ${
                                this.emza1.binary
                              }" />
                            </div> 
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis2
                              }</div>
                              <img style="height: 10vh;margin-top:-40px;" src="data:image/png;base64,${
                                this.emza2.binary
                              }" />
                            </div>
                          </div>
                        </div>
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">
                           با صدور این برگه، برگه های قبلی فاقد اعتبار می‌باشد 
                        </div>

                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (
        this.$session.get("CustCode") == 8002 ||
        this.$session.get("CustCode") == 850
      ) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${
                                    this.$session.get("UserInfoNetPa").perNo ==
                                    null
                                      ? " - - - "
                                      : this.$session.get("UserInfoNetPa").perNo
                                  }</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 13px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 13px">تعاونی اعتبار کارکنان دانشگاه علوم پزشکی [تربت حیدریه]</div>
     
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(
                                  this.DataAxiosSaham.arzeshHarSahm,
                                )} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${
                                  this.$session.get("UserInfoNetPa").ozvName
                                } ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar
                                  ? this.$session.get("UserInfoNetPa").pedar
                                  : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${
                                this.$session.get("UserInfoNetPa").codeMeli
                              } </span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="mr-5 font-16px"> تعداد سهام</span><span class="font-weight-bold"> ${Math.floor(
                                Taahoadat.mande
                                  .replace(/,/g, "")
                                  .replace(/\./g, "") /
                                  this.DataAxiosSaham.arzeshHarSahm,
                              )} سهم</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${
                            this.logo.binary
                          } " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${
                              this.DataAxiosSaham.shomareSabt
                            }</div>
                            <div class="">شناسه ملی : ${
                              this.DataAxiosSaham.shenaseMeli
                            }</div>
                            <div class="">تاریخ ثبت شرکت: ${
                              this.DataAxiosSaham.tarixSabt
                            }</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis1
                              }</div>
                              <img style="height: 10vh;margin-top:-35px;" src="data:image/png;base64, ${
                                this.emza1.binary
                              }" />
                            </div>
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis2
                              }</div>
                              <img style="height: 10vh;margin-top:-40px;" src="data:image/png;base64,${
                                this.emza2.binary
                              }" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 874) {
        html = `
        <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class="m-1 py-2 w-100" style="line-height:1.5">
                      <div class="row mt-3" dir="ltr">
                        <div class="col-3 text-left pl-[40px]" style="margin-left: 1.2cm"><img style="max-width:4cm;height:1.8cm;object-fit:contain" src="data:image/png;base64,${
                          this.logo.binary
                        }" /></div>
                        <div class="col-6 text-center d-flex align-items-center justify-content-center">
                          <div class="font-weight-bold mt-0" style="font-size: 13px">شرکت تعاونی اعتبار کارکنان وزارت جهاد کشاورزی</div>
                        </div>
                        <div class="col-3"></div>
                      </div>
                      <div class="row mt-2 px-3" dir="ltr">
                        <div class="col-6 text-left pl-5 pr-2">تاریخ چاپ : ${
                          this.$GetJalaliDate().split(" ")[0]
                        }</div>
                        <div class="col-6 text-right pl-2 pr-5">شماره ثبت شرکت : ${
                          this.DataAxiosSaham.shomareSabt
                        }</div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-12 text-center" style="font-size: 14px">مبلغ اسمی هر سهم ${this.$Comma3ragham(
                          this.DataAxiosSaham.arzeshHarSahm,
                        )} ریال</div>
                      </div>
                      <div class="row" style="margin-top: 1.25rem">
                        <div class="col-12 text-right pr-5 font-16px">مشخصات سهامدار</div>
                      </div>
                      <div class="row">
                        <div class="col-12 pr-5 text-right" style="width: 80%; max-width: 80%; direction: rtl">
                          <div class="row mt-2" style="line-height: 1.55">
                            <div class="col-4 font-16px"><span class="font-16px">نام :</span> <span class="font-weight-bold font-16px">${
                              this.$session.get("UserInfoNetPa").ozvName
                            }</span></div>
                            <div class="col-4 font-16px"><span class="font-16px">نام خانوادگی :</span> <span class="font-weight-bold font-16px">${
                              this.$session.get("UserInfoNetPa").ozvFamily
                            }</span></div>
                            <div class="col-4 font-16px"><span class="font-16px">نام پدر :</span> <span class="font-weight-bold font-16px">${
                              this.$session.get("UserInfoNetPa").pedar
                                ? this.$session.get("UserInfoNetPa").pedar
                                : "______"
                            }</span></div>
                          </div>
                          <div class="row mt-2" style="margin-top: 0.6rem">
                            <div class="col-4 font-16px"><span class="font-16px">کد ملی :</span> <span class="font-weight-bold font-16px" dir="rtl">${
                              this.$session.get("UserInfoNetPa").codeMeli
                            }</span></div>
                            <div class="col-4 font-16px"><span class="font-16px">شماره عضویت :</span> <span class="font-weight-bold font-16px" dir="rtl">${
                              this.$session.get("UserInfoNetPa").shomareOzv
                            }</span></div>
                            <div class="col-4 font-16px"></div>
                          </div>
                          <div class="row mt-2" style="margin-top: 0.6rem">
                            <div class="col-4 font-16px"><span class="font-16px">دارای سهام به تعداد</span> <span class="font-weight-bold font-16px">${Math.floor(
                              Taahoadat.mande
                                .replace(/,/g, "")
                                .replace(/\./g, "") /
                                this.DataAxiosSaham.arzeshHarSahm,
                            )}</span></div>
                            <div class="col-4 font-16px" style="white-space: nowrap"><span class="font-16px">سهم، معادل</span> <span class="font-weight-bold font-16px pr-3">${this.$Comma3ragham(
                              Math.floor(
                                Taahoadat.mande
                                  .replace(/,/g, "")
                                  .replace(/\./g, ""),
                              ),
                            )}</span></div>
                            <div class="col-4 font-16px">ریال</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-12 text-right text-center" style="font-size: 12px !important;line-height:1.4">با صدور این ورقه، کلیه‌ی اوراق سهام قبلی صادره از درجه اعتبار ساقط است</div>
                      </div>

                      <div class="row mt-2">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center">
                          <div class="row no-gutters" style="gap: 0 1rem; justify-content: center;">
                            <div class="col-md-6 col-12 text-center" style="max-width: 45%;">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis1
                              }</div>
                              <img style="height: 12vh; min-width: 140px; object-fit: contain; display:block; margin:0.35rem auto 0;" src="data:image/png;base64, ${
                                this.emza1.binary
                              }" />
                            </div>
                            <div class="col-md-6 col-12 text-center" style="max-width: 45%;">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${
                                this.DataAxiosSaham.pishNevis2
                              }</div>
                              <img style="height: 12vh; min-width: 140px; object-fit: contain; display:block; margin:0.35rem auto 0;" src="data:image/png;base64,${
                                this.emza2.binary
                              }" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      // console.log(html);
      var htmlObject = document.createElement("div");
      htmlObject.innerHTML = html;
      html2pdf(htmlObject, {
        jsPDF: { format: "a5", orientation: "landscape" },
      });
    },
    CalcEmtiazXasForTable(EmtizatPerson) {
      let sum = 0;
      EmtizatPerson.forEach((el) => {
        if (el.Base != null) {
          sum += el.Emtiaz;
        }
      });
      return sum;
    },
    Mab2persian() {
      var Mab = this.DataAxiosSaham.arzeshHarSahm + "";
      Mab = this.$b_ToPersianNumber(Mab);
      // Mab=Mab/10
      return Num2persian(Mab) + " " + this.$GetVahedPool() + "ی";
    },
    openGeneratorQR(taahodat) {
      this.$router.push({
        name: "GeneratorLinkPay",
        params: { Taahodat: taahodat },
      });
    },
  },
};
</script>
<style scoped>
.fl {
  float: left !important;
}
.bg-gray {
  background: #cecece !important;
}
.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 18px 22px;
  border-radius: 15px;
  margin-top: 16px;
  margin-bottom: 16px;
  height: 100%;
  box-sizing: border-box;
}

.costom-card-sahebanhesab {
  padding: 18px 22px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #95f1b4;
  margin-top: 16px;
  margin-bottom: 16px;
  height: 100%;
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .costom-card,
  .costom-card-sahebanhesab {
    margin-top: 24px;
    margin-bottom: 24px;
    padding: 20px 28px;
  }
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.btn-secondary:hover {
  outline: none !important;
  border: solid 1px gray !important;
}
</style>
<style>
#Accounts .account-cards-grid {
  margin-left: -10px;
  margin-right: -10px;
  row-gap: 4px;
}

#Accounts .account-card-col {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 12px;
}

#Accounts .costom-card .border-bottom > .col-12 > hr,
#Accounts .costom-card-sahebanhesab .border-bottom > .col-12 > hr {
  margin-top: 0.35rem;
  margin-bottom: 0.25rem;
}

#Accounts .account-card-body-main {
  padding-top: 0;
  margin-top: 0;
}

#Accounts .account-card-fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: 0;
  margin-bottom: 0.65rem;
  padding-top: 0;
}

#Accounts .account-card-field-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: right;
}

#Accounts .account-card-field-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#Accounts .account-card-field-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#Accounts .account-card-balance-footer {
  margin: 0;
  padding: 6px 0 10px;
  border-top: 1px solid #e8ecf1;
}

#Accounts .account-card-balance-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: right;
  padding: 0;
  margin: 0;
}

#Accounts .account-card-balance-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 0;
  text-align: right;
}

#Accounts .account-card-balance-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#Accounts .account-card-balance-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#Accounts .account-card-actions {
  margin-left: 0;
  margin-right: 0;
  row-gap: 8px;
}

#Accounts .account-card-actions > [class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;
}

#Accounts .btn-outline-success.NetPa-btn {
  color: #55941a;
  background-color: #fff;
  border-color: #5ea31e;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-weight: 600;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

#Accounts .btn-outline-success.NetPa-btn:hover,
#Accounts .btn-outline-success.NetPa-btn:focus {
  color: #fff !important;
  background-color: #55941a !important;
  border-color: #55941a !important;
  box-shadow: 0 2px 6px rgba(85, 148, 26, 0.28);
}

#Accounts .btn-outline-success.NetPa-btn:active {
  color: #fff !important;
  background-color: #4a8017 !important;
  border-color: #4a8017 !important;
}

#Accounts .accounts-list-view .vbt-table-wrapper td {
  vertical-align: middle;
}

#Accounts .accounts-list-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

#Accounts .accounts-list-meta {
  margin-top: 6px;
  font-size: 11px;
  color: #6c757d;
  line-height: 1.4;
}

#Accounts .accounts-list-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 28px;
  padding: 0.2rem 0.6rem;
  margin: 0;
  border-radius: 7px !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

#Accounts .accounts-list-btn--detail {
  color: #2a3f54;
  background: #fff;
  border: 1px solid #c5ced9;
}

#Accounts .accounts-list-btn--detail:hover,
#Accounts .accounts-list-btn--detail:focus {
  color: #fff !important;
  background: #2a3f54 !important;
  border-color: #2a3f54 !important;
}

#Accounts .accounts-list-view .btn-outline-success.accounts-list-btn {
  color: #55941a;
  background-color: #fff;
  border-color: #5ea31e;
}

#Accounts .accounts-list-view .btn-outline-success.accounts-list-btn:hover,
#Accounts .accounts-list-view .btn-outline-success.accounts-list-btn:focus {
  color: #fff !important;
  background-color: #55941a !important;
  border-color: #55941a !important;
}

#Accounts .accounts-list-view .btn-outline-dark.accounts-list-btn:hover,
#Accounts .accounts-list-view .btn-outline-dark.accounts-list-btn:focus {
  color: #fff !important;
  background-color: #2a3f54 !important;
  border-color: #2a3f54 !important;
}

#Accounts
  .accounts-list-view
  .btn-outline-danger.accounts-list-btn:hover:not(:disabled),
#Accounts
  .accounts-list-view
  .btn-outline-danger.accounts-list-btn:focus:not(:disabled) {
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}

#Accounts .accounts-list-view .footer-pagination-row > td {
  padding: 0.65rem 0.75rem;
  background: #f8f9fb;
  border-top: 1px solid #e8ecf1;
}

#Accounts .accounts-list-view .vbt-pagination-row {
  align-items: center;
  margin: 0;
}

#Accounts .accounts-list-view .vbt-pagination-row > .col-md-8 {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0;
}

#Accounts .accounts-list-view .vbt-pagination-row > .col-md-4 {
  display: none;
}

#Accounts .accounts-list-view .vbt-pagination-row > .col-md-8 > div,
#Accounts .accounts-list-view .footer-pagination-row nav {
  width: 100%;
}

#Accounts .accounts-list-view .pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 0;
  clear: none !important;
}

#Accounts .accounts-list-view .pagination .page-item {
  margin: 0;
  clear: none !important;
}

#Accounts .accounts-list-view .pagination .page-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 0.55rem;
  margin: 0;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  background: #fff;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

#Accounts .accounts-list-view .pagination .page-item.active .page-link {
  background: #2a3f54;
  border-color: #2a3f54;
  color: #fff;
}

#Accounts .accounts-list-view .pagination .page-item.disabled .page-link {
  background: #f0f2f5;
  border-color: #e8ecf1;
  color: #adb5bd;
}

#Accounts .accounts-list-view .pagination .page-link:hover {
  background: #eef1f5;
  border-color: #c5ced9;
  color: #2a3f54;
}

#Accounts .accounts-list-view .pagination .page-item.active .page-link:hover {
  background: #243547;
  border-color: #243547;
  color: #fff;
}

#Accounts .accounts-list-view .vbt-per-page-dropdown {
  display: inline-flex;
  align-items: center;
  align-self: center;
  margin: 0 !important;
  clear: none !important;
}

#Accounts .accounts-list-view .vbt-per-page-dropdown .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 52px;
  height: 32px;
  padding: 0 0.6rem;
  margin: 0;
  clear: none !important;
  border-radius: 8px;
  background: #2a3f54 !important;
  border: 1px solid #2a3f54 !important;
  color: #fff !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: none;
}

#Accounts
  .accounts-list-view
  .vbt-per-page-dropdown
  .btn.dropdown-toggle::before {
  display: none !important;
  content: none !important;
  border: none !important;
  margin: 0 !important;
  float: none !important;
}

#Accounts
  .accounts-list-view
  .vbt-per-page-dropdown
  .btn.dropdown-toggle::after {
  display: inline-block !important;
  flex-shrink: 0;
  margin: 0 !important;
  vertical-align: middle !important;
  align-self: center;
  border-top: 0.32em solid;
  border-right: 0.32em solid transparent;
  border-bottom: 0;
  border-left: 0.32em solid transparent;
  border-top-color: currentColor;
}

#Accounts .accounts-list-view .vbt-per-page-dropdown .btn:hover,
#Accounts .accounts-list-view .vbt-per-page-dropdown .btn:focus {
  background: #243547 !important;
  border-color: #243547 !important;
  color: #fff !important;
}

#Accounts .accounts-list-view .pagination .input-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: auto !important;
  max-width: none;
  height: 32px;
  margin: 0;
  margin-inline-start: auto;
  flex: 0 0 auto;
  padding: 0;
  order: 99;
}

#Accounts .accounts-list-view .pagination .input-group.col-sm-2 {
  flex: 0 0 auto;
  max-width: none;
}

#Accounts .accounts-list-view .pagination .input-group::before {
  content: "برو به صفحه:";
  display: inline-flex;
  align-items: center;
  height: 32px;
  color: #495057;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

#Accounts .accounts-list-view .pagination .input-group .form-control {
  width: 64px;
  min-width: 64px;
  height: 32px;
  min-height: 32px;
  padding: 0 0.4rem;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  background: #fff;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  box-shadow: none;
  -moz-appearance: textfield;
}

#Accounts
  .accounts-list-view
  .pagination
  .input-group
  .form-control::-webkit-outer-spin-button,
#Accounts
  .accounts-list-view
  .pagination
  .input-group
  .form-control::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#Accounts
  .accounts-list-view
  .pagination
  .input-group
  .form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}

#Accounts .accounts-list-view .pagination .input-group .form-control:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.12);
}

#Accounts .accounts-list-view .vbt-per-page-dropdown .dropdown-menu {
  min-width: 72px;
  padding: 0.25rem 0;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(42, 63, 84, 0.12);
  font-size: 12px;
}

#Accounts .accounts-list-view .vbt-per-page-dropdown .dropdown-item {
  padding: 0.35rem 0.75rem;
  font-weight: 600;
  color: #2a3f54;
}

#Accounts .accounts-list-view .vbt-per-page-dropdown .dropdown-item.active,
#Accounts .accounts-list-view .vbt-per-page-dropdown .dropdown-item:hover {
  background: #f0f2f5;
  color: #2a3f54;
}

@media (max-width: 767px) {
  #Accounts .accounts-list-view .footer-pagination-row > td {
    padding: 0.55rem 0.5rem;
  }

  #Accounts .accounts-list-view .pagination {
    justify-content: flex-start;
  }

  #Accounts .accounts-list-view .pagination .input-group {
    margin-inline-start: auto;
    order: 99;
  }
}

#Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .modal-dialog {
  margin: 1.25rem auto;
  max-width: 640px;
  width: calc(100% - 2.5rem);
}

#Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  width: 100%;
  max-height: calc(100vh - 2.5rem);
}

#Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .modal-body {
  padding: 0;
  position: relative;
}

#Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .close {
  position: absolute;
  top: 0.85rem;
  left: 0.85rem;
  z-index: 2;
  float: none;
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54 !important;
  opacity: 1;
  text-shadow: none;
  font-size: 1.35rem;
  line-height: 1;
}

#Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .close:hover {
  background: rgba(42, 63, 84, 0.14);
  color: #1a2a3a !important;
}

.netpa-account-detail-modal__panel {
  background: #fff;
  padding: 1rem 1.15rem 1.25rem;
  text-align: right;
}

.netpa-account-detail-modal__header {
  margin-bottom: 0.85rem;
  padding-bottom: 0;
  padding-left: 2.5rem;
}

.netpa-account-detail-modal__title {
  margin: 0;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

.netpa-account-detail-modal__title .fa-info-circle {
  color: #435ebe;
}

.netpa-account-detail-modal__header-divider {
  margin: 0.75rem 0;
  border: 0;
  border-top: 1px solid #e8ecf1;
  opacity: 1;
}

.netpa-account-detail-modal__account-type {
  margin: 0;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e8ecf1;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  line-height: 1.5;
}

.netpa-account-detail-modal__account-type .fa-money-check {
  color: #28a745;
}

.netpa-account-detail-modal__grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.netpa-account-detail-modal__item {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.5rem 0.65rem;
  border-radius: 8px;
  background: #f8f9fb;
}

.netpa-account-detail-modal__label {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  white-space: nowrap;
  flex-shrink: 0;
  text-align: right;
}

.netpa-account-detail-modal__value {
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  word-break: break-word;
  text-align: left;
  flex: 0 1 auto;
  min-width: 0;
}

.netpa-account-detail-modal__section-title {
  margin: 0.15rem 0 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid #e8ecf1;
  font-size: 14px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

.netpa-account-detail-modal__section-title .fa-ban {
  color: #e67e22;
}

.netpa-account-detail-modal__score {
  margin-top: 0.75rem;
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  background: #f0f4ff;
  border: 1px solid rgba(67, 94, 190, 0.15);
  text-align: center;
}

.netpa-account-detail-modal__score-note {
  margin: 0.35rem 0 0;
  font-size: 14px;
  color: #2a3f54;
  line-height: 1.6;
}

.netpa-account-detail-modal__score-note strong {
  color: #d97706;
  font-weight: 700;
}

@media (max-width: 767px) {
  #Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .modal-dialog {
    margin: 1rem auto;
    width: calc(100% - 2rem);
    max-width: calc(100% - 2rem);
  }

  #Accounts #Modal-Mobile:has(.netpa-account-detail-modal) .modal-content {
    border-radius: 16px;
    max-height: calc(100vh - 2rem);
  }

  .netpa-account-detail-modal__panel {
    padding: 0.9rem 1rem 1.1rem;
  }

  .netpa-account-detail-modal__header {
    padding-left: 2.25rem;
  }

  .netpa-account-detail-modal__label {
    white-space: normal;
  }
}

@media print {
  .no-print {
    display: none;
  }
}

.Border {
  /* border: 3px solid rgb(0, 0, 0); */
  border: 9px double rgb(53, 120, 223);
}
.Border-Rouded {
  border: 3px solid rgb(0, 0, 0);
  border-radius: 8px;
}
.font-16px {
  font-size: 12px !important;
}
</style>
<style>
/* Certificate 874: exact match for print/export (no scoped so injected HTML gets styles) */
@media print {
  body {
    margin: 0 !important;
    padding: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
.certificate-874 {
  width: 20.5cm !important;
  height: 14.4cm !important;
  min-width: 20.5cm;
  min-height: 14.4cm;
  max-width: 20.5cm;
  overflow: hidden;
  page-break-inside: avoid;
}
.certificate-874 * {
  font-weight: inherit;
}
.certificate-874 [style*="font-weight:700"],
.certificate-874 [style*="font-weight: 700"] {
  font-weight: 700 !important;
}
</style>
